export const defaultEnvironment = {
  production: false,
  cdnUrl: "",
  htmlBaseUrl: "/",
  assetsPath: "assets",
  faviconName: "favicon",
  safariIconColor: "#ff8700",
  envName: "",

  airbrake: {
    projectId: 108773,
    key: "0a5e0ee614ab2c18c2ae84980438fd73",
    host: "https://airbrake.io",
  },
};
